module.exports = __webpack_public_path__ + "img/square-arrow-left.ee5b3130.svg";